import { useMutation } from "@tanstack/react-query"
import { useConfig } from "hooks/use-config"
import { useToast } from "hooks/use-toast"
import { transcribeAudioToText } from "../services/speech-to-text-service";
import { useTranslation } from "react-i18next";

export const useSpeechToText = () => {
    const { configurationSettings } = useConfig();
    const { toast } = useToast();
    const { t } = useTranslation();
    
    return useMutation({
        mutationFn: async (audioBlob: Blob) => {
            return await transcribeAudioToText(audioBlob, configurationSettings)
        },
        onSuccess: (data) => {
            console.log('Speech to text data: ', data);
        },
        onError: (error) => {
            toast({
                title: t('ERROR'),
                description: t('AUDIO_TRANSCRIPTION_FAILED'),
                variant: 'destructive',
            })
        }
    })  
}
